module.exports = __webpack_public_path__ + "img/saddle-cloths-3.f1cb069d.svg";